/**
 * 验证类
 */


import * as Tools from "./tools";
import * as Dialog from "./dialog";

let regex = function(re, value){
    return Tools.empty(value) || re.test(value);
}

let default_rules = {
    regex: (re, value) => regex(re, value)
    ,bool: (value) => value
    ,required: (value) => !Tools.empty(value)
    ,min: (value, min) => !Tools.empty(value) && value.length >= min
    ,max: (value, max) => Tools.empty(value) || value.length <= max
    ,length: (value, min, max) => !Tools.empty(value) && value.length >= min && value.length <= max
    ,isMobile: (value) => regex(/^1\d{10}$/, value)
}

/**
 * 验证单条规则
 * @param rule_name
 * @param value
 * @param value1
 * @param value2
 * @returns {*}
 */
export const regexRule = function(rule_name, value, value1, value2){
    return default_rules[rule_name](value, value1, value2);
}

/**
 * 验证单个值多个信息
 * @param value
 * @param rules
 * @returns {boolean}
 */
export const check = function (value, rules) {
    for(let i in rules){
        let rule = rules[i];
        let rule_data = rule[0].split(',');
        let rule_name = rule_data[0];
        let rule_data1 = rule_data.length > 1 ? rule_data[1] : undefined;
        let rule_data2 = rule_data.length > 2 ? rule_data[2] : undefined;
        let msg = rule[1];
        let res = default_rules[rule_name](value, rule_data1, rule_data2);
        if(!res){
            return msg;
        }
    }
    return true;
}

/**
 * 多项验证
 * @param data
 * @param rules
 * @returns {boolean|{msg, field: string}}
 */
export const checkForm = function (data, rules) {
    let result = [];
    for(let field in rules){
        let value = Tools.empty(data[field]) ? null : data[field];
        let msg = this.check(value, rules[field]);
        if(msg !== true) {
            result.push({field, msg});
        }
    }
    if(Tools.empty(result)) return true;
    for(let i in result){
        Dialog.toast(result[i].msg, {});
        break;
    }
    return result;
}

